import JWT from 'jsonwebtoken'
import store from '@/store'
import permissions from './permissions'

const ALL_ROLES = ['admin', 'operator', 'customer']

const evalRoles = (roles = []) => {
  if (roles.length <= 0) { return true }
  return roles.includes(store.getters.currentRole)
}

const canUser = (role, action, entity) => {
  return permissions[entity][role][action]
}

const verifyToken = () => {
  // if token exists
  let currentToken = store.getters.currentToken
  if (!currentToken) { return false }
  // if token is valid
  let tokenData = JWT.decode(currentToken)
  let tokenExp = new Date(tokenData.exp * 1000)
  let datenow = new Date()
  if (datenow > tokenExp) { return false }
  return true
}

export default {
  authorize: (roles = []) => {
    if (verifyToken()) { return evalRoles(roles) }
    return false
  },
  permitActions: (entity = 'default') => {
    let role = store.getters.currentRole
    return permissions[entity][role]
  },
  getRoles: (entity, action) => {
    let users = []
    ALL_ROLES.forEach((user) => {
      if (canUser(user, action, entity)) { users.push(user) }
    })
    return users
  },
  can: (action, entity = 'default') => {
    let role = store.getters.currentRole
    if (verifyToken() && permissions[entity][role][action]) {
      return true
    }
    return false
  },
  isAdmin: () => {
    if (store.getters.currentRole === 'admin') { return true }
    return false
  },
  isOperator: () => {
    if (store.getters.currentRole === 'operator') { return true }
    return false
  },
  isCustomer: () => {
    if (store.getters.currentRole === 'customer') { return true }
    return false
  },
  isLogged: verifyToken
}



// WEBPACK FOOTER //
// ./src/utils/Policeman/policeman.js